import React from 'react'
import Page, {
  DescriptionText,
  StyledPaper,
  StyledFormContainer,
} from 'Event/template/Cards/Login/Page'
import {useGuestVariables} from 'Event'
import {TitleText} from 'Event/template/Cards/Login/Title'
import Configurable from 'organization/Event/Configurable'
import OfflineContentConfig from 'Event/template/Cards/EventOfflinePage/OfflineContentConfig'
import {OfflinePageProps} from 'Event/JoinArea/OfflinePage'
import {useCardsTemplate} from 'Event/template/Cards'

export default function EventOfflinePage(props: OfflinePageProps) {
  const v = useGuestVariables()
  const template = useCardsTemplate()
  const {linkColor, linkUnderline} = template

  return (
    <Page isPreview={props.isPreview || false}>
      <Configurable
        aria-label="event offline content config"
        dataTestId="event offline config"
      >
        <OfflineContentConfig />
        <StyledPaper>
          <StyledFormContainer>
            <OfflineTitle>{v(props.title)}</OfflineTitle>
            <DescriptionText
              linkColor={linkColor}
              linkUnderline={linkUnderline}
            >
              <div dangerouslySetInnerHTML={{__html: v(props.description)}} />
            </DescriptionText>
          </StyledFormContainer>
        </StyledPaper>
      </Configurable>
    </Page>
  )
}

function OfflineTitle(props: {children: string}) {
  const {textColor, offlinePage, login} = useCardsTemplate()

  if (!props.children) {
    return null
  }

  return (
    <TitleText
      textColor={textColor}
      titleTextColor={offlinePage.titleTextColor ?? login.welcome.color}
      fontSize={offlinePage.titleFontSize ?? login.welcome.fontSize}
      font={login.welcome.font}
    >
      {props.children}
    </TitleText>
  )
}
